import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SEOLanding from "@/pages/SEOLanding";
import Grazie from "@/pages/Grazie";
import CRM from "@/pages/CRM";
import Dashboard from "@/pages/Dashboard";
import GalleryAdmin from "@/pages/GalleryAdmin";
import Login from "@/pages/Login";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieConsent from "@/components/site/CookieConsent";
import { AuthProvider } from "@/context/AuthContext";
import { initTracking, trackPageView } from "@/lib/tracking";
import { captureAttribution } from "@/lib/attribution";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    captureAttribution();
    initTracking();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />
            <Route path="/crm/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/crm/galleria" element={<ProtectedRoute><GalleryAdmin /></ProtectedRoute>} />
            <Route path="/grazie" element={<Grazie />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/:slug" element={<SEOLanding />} />
          </Routes>
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
